import { MEDIA_DIMENSIONS } from "./constants";

export const buildResizeImagePayload = ({
  urls,
  format,
  formats,
  width,
  height,
}) => {
  const resolvedFormats = Array.isArray(formats)
    ? formats
    : format
      ? [format]
      : [];

  const payload = { urls, formats: resolvedFormats };

  const includesCustom = resolvedFormats.includes(MEDIA_DIMENSIONS.custom);
  if (includesCustom) {
    payload.width = Number(width);
    payload.height = Number(height);
  }

  return payload;
};

export const getResizingFormatItemPatch = ({ format, width, height }) => {
  const patch = { resizingFormat: format };

  if (format === MEDIA_DIMENSIONS.custom) {
    patch.resizingWidth = Number(width);
    patch.resizingHeight = Number(height);
  }

  return patch;
};

export const clearResizingFormatItemPatch = () => ({
  resizingFormat: undefined,
  resizingWidth: undefined,
  resizingHeight: undefined,
});
